import { render, staticRenderFns } from "./VerifyLayout.vue?vue&type=template&id=bb0c87c6&scoped=true&"
import script from "./VerifyLayout.vue?vue&type=script&lang=js&"
export * from "./VerifyLayout.vue?vue&type=script&lang=js&"
import style0 from "./VerifyLayout.vue?vue&type=style&index=0&id=bb0c87c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c87c6",
  null
  
)

export default component.exports